import { dataProps } from './properties'

export const setVendorPaymentList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
state.nav.page_number = payload.page_number
if(!state.nav.had_results) {
   state.nav.had_results = payload.total>0
}
}    

export const setVendorPaymentData = (state, payload) => {
    state.props = payload.response    
} 

export const resetVendorPaymentPartial = state => {
    state.props.paid_amount = 0
    state.props.bank_id = null
} 

export const resetVendorPaymentData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/vendorPayment/mutations.js